import { FormItemProps } from 'antd'

export const requiredRules: FormItemProps['rules'] = [{ required: true }]
